module.exports = __webpack_public_path__ + "static/media/logo.c3fa0c18.svg";